import { intersects } from "@supliful/domain"

import type { CarrierFragment } from "lib/graphql"
import { AdminPermission } from "lib/graphql"

export const getLogoByCarrierSlug = (carrier?: string): string | undefined => {
  let logo
  const logoMap = {
    fedex: "/logos/fedex-logo.png",
    usps: "/logos/usps-logo.png",
    ups: "/logos/ups-logo.png",
    passport: "/logos/passport-logo.png",
    dhl: "/logos/dhl-logo.png",
    pasts: "/logos/latvijas-pasts-logo.png",
  }

  if (!carrier) {
    return undefined
  }

  Object.entries(logoMap).forEach(([slug, src]) => {
    if (carrier.toLowerCase().includes(slug)) {
      logo = src
    }
  })

  return logo
}

export const getCarrierExternalIdBySlug = ({
  carrierSlug,
  warehouseId,
  carriers = [],
}: {
  carrierSlug: string
  warehouseId: string
  carriers: CarrierFragment[]
}): string | undefined => {
  return carriers.find(
    (carrier) =>
      carrier.warehouseId === warehouseId && carrier.slug === carrierSlug,
  )?.externalId
}

export const printShippingLabel = async ({
  labelUrl,
  onLoadingStart,
  onLoadingEnd,
}: {
  labelUrl: string | string[]
  onLoadingStart?: () => void
  onLoadingEnd?: () => void
}) => {
  // Since print-js depends on the `window` object, load it dynamically on the client side.
  // @see https://nextjs.org/docs/advanced-features/dynamic-import#with-external-libraries
  const printJS = (await import("print-js")).default

  const firstLabelUrl = Array.isArray(labelUrl) ? labelUrl[0] : labelUrl
  const extension = firstLabelUrl.split(".").pop()?.toLowerCase()
  const type = extension === "pdf" ? "pdf" : "image"

  printJS({
    printable: labelUrl,
    type,
    showModal: true,
    onLoadingStart: () => {
      if (onLoadingStart) onLoadingStart()
    },
    onLoadingEnd: () => {
      if (onLoadingEnd) onLoadingEnd()
    },
  })
}

export const isAuthorized = (
  userPermissions: AdminPermission[] | undefined,
  permissionsNeeded: AdminPermission[],
) => {
  // user must either have EVERYTHING permission or one of the permissions listed in permissionsNeeded
  return intersects(userPermissions, [
    AdminPermission.Everything,
    ...permissionsNeeded,
  ])
}
